import React from 'react';
import ReactDOM from 'react-dom/client';
import Login from './Pages/Login/Login'
import FindCotizacion from './Pages/Cotizaciones/FindCotizacion';
import PDFView from "./Pages/Pagos/PDFView";
import  Desglose  from "./Pages/Desglose/Pagos";
import Pago from "./Pages/Pagos/Pago";
import Pagos from "./Pages/Pagos/Pagos";
import FactView from "./Pages/Desglose/FactView";
import PayView from "./Pages/Desglose/PayView";
import LinView from "./Pages/LinkView/LinkView";
import LinViewOld from "./Pages/LinkView/LinkViewOld";
import PdfC from "./Components/PDF/PdfC";
import PdfoC from "./Components/PDF/Pdf_Oc";
import { BrowserRouter, Routes, Route } from "react-router";
import reportWebVitals from './reportWebVitals';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Routes>
      <Route path="" element={<Login />} />
      <Route path="/FindCotizacion" element={<FindCotizacion />} />
      <Route path="/Desglose" element={<Desglose/>} />
      <Route path="/Pago" element={<Pago />} />
      <Route path="/Pagos" element={<Pagos />} />
      <Route path="/PDFView" element={<PDFView />} />
      <Route path="/FactView" element={<FactView />} />
      <Route path="/PayView" element={<PayView />} />
      <Route path="/Link/:hash/:id" element={<LinView />} />
      <Route path="/PDF" element={<LinViewOld />} />
      <Route path="/LinkCot/:hash/:id" element={<PdfC />} />
      <Route path="/LinkOc/:hash" element={<PdfoC />} />
      </Routes>
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
